import {serverApiUrl} from "../index"

export const getExpoId=(category,page,offset,callback)=>
{
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  
    let headers = new Headers(); 
    headers.append('Content-Type', 'application/json');  
    headers.append('Access-Control-Allow-Origin', serverApiUrl);
    headers.append('Access-Control-Allow-Credentials', 'true'); 
    headers.append('GET', 'POST', 'OPTIONS'); 

        fetch(serverApiUrl+"institute/category/expo/"+category+"/"+offset+"/"+page,
        {
            method: 'GET',  
            headers,
             
        })
    .then((response)=>callback(response)) 
    .catch((error)=>{console.log(error)})
}



export const sendNotification=( title, url, message,courseId,callback)=>
{
    let headers = new Headers(); 
    headers.append('Content-Type', 'application/json');  
    headers.append('Access-Control-Allow-Origin', serverApiUrl);
    headers.append('Access-Control-Allow-Credentials', 'true'); 
    headers.append('GET', 'POST', 'OPTIONS'); 


    
     
        fetch(serverApiUrl+"notification/send/notificationIns",
        {
            method: 'POST',  
            headers,
            body:JSON.stringify({title,url,message,courseId:parseInt(courseId),type:"test"})
        })
    .then((response)=>callback(response)) 
    .catch((error)=>{console.log(error)})
}